import { styled, css, ButtonBase } from '@mui/material'
import getPaletteColor from '../../../../utils/getPaletteColor'
import Icon from '../../Icon'

export interface SelectButtonProps {
  label: string
}

const StyledSelectButton = styled(ButtonBase)(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;
    height: 32px;
    width: 100%;
    padding: 4px;
    padding-left: 10px;
    border-radius: 8px;
    font-size: 11px;
    font-weight: bold;
    text-align: left;
    color: ${theme.palette.common.white};
    background-color: ${theme.palette.text.primary};
    transition: background-color 0.2s ease-in-out;

    &:hover {
      background: ${getPaletteColor(
        theme,
        theme.palette.text.primary,
        'light'
      )};
    }

    .Icon {
      box-sizing: initial;
      border-radius: 6px;
      padding: 3px;
      font-size: 18px;
      color: ${theme.palette.text.primary};
      background-color: ${theme.palette.common.white};
    }
  `
)

const SelectButton = ({ label }: SelectButtonProps) => {
  return (
    <StyledSelectButton className="SelectButton">
      {label}
      <Icon name="MdAdd" />
    </StyledSelectButton>
  )
}

export default SelectButton
